import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  inputLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.primary,
    zIndex: 1,
  },
  addSpeakerButtonContent: {
    textTransform: "none",
  },
  table: {
    "& .MuiTableHead-root": {
      backgroundColor: theme.palette.events.blueSecondary,
    },
    "& .MuiTablePagination-displayedRows": {
      display: "none",
    },
    "& .MuiTypography-root.MuiTypography-caption": {
      color: theme.palette.text.tertiary,
    },
  },
}));

export const styles = {
  attendeeList: {
    marginBottom: "50px",
  },
};
